module.exports = __webpack_public_path__ + "img/erW.1f7e042e.png";